import { GridRowSelectionModel } from '@mui/x-data-grid';
import { useCallback, useState } from 'react';

interface Params {
  onBeforeSelectionChange?: () => void;
}

const getEmptyRowSelectionModel = (): GridRowSelectionModel => ({ type: 'include', ids: new Set() });

export const useDataGridRowSelection = ({ onBeforeSelectionChange }: Params = {}) => {
  const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>(getEmptyRowSelectionModel);

  const handleRowSelectionModelChange = useCallback(
    (nextRowSelectionModel: GridRowSelectionModel) => {
      onBeforeSelectionChange?.();
      setRowSelectionModel({ type: 'include', ids: new Set(nextRowSelectionModel.ids) });
    },
    [onBeforeSelectionChange]
  );

  const clearSelection = useCallback(() => {
    onBeforeSelectionChange?.();
    setRowSelectionModel(getEmptyRowSelectionModel());
  }, [onBeforeSelectionChange]);

  return {
    rowSelectionModel,
    selectedIds: rowSelectionModel.ids,
    selectedCount: rowSelectionModel.ids.size,
    onRowSelectionModelChange: handleRowSelectionModelChange,
    onPaginationModelChange: clearSelection,
    clearSelection
  };
};
